<script>
import common from '../../../../common.js'
import { Bar, mixins } from 'vue-chartjs'
import { BigNumber } from 'bignumber.js'


export default {
  extends: Bar,
  mixins: [mixins.reactiveProp], // reactivePropを使用
  props: ['chartData'],
  data() {
    return {
      options: {
        legend: {
          display: false
        },
        scales: {
          xAxes: [{
            barPercentage: 1,  // 棒グラフ幅
            categoryPercentage: 0.4,
            gridLines: {
              display: false,
            },
          }],
          yAxes: [{
            gridLines: {
              drawBorder: false,
            },
            ticks: {
              min: 0,
              userCallback: function(label, index, labels) {
                if (label === 0) return 0;
                let converted = new BigNumber(label / common.VALUE_RATE.number);

                // データ値に応じて、Y軸ラベルの小数表示を調整
                if (converted.isLessThanOrEqualTo(0.2)) {
                  if (converted.modulo(0.1).isZero()) {
                    return converted.toFixed(1);
                  } else if (converted.modulo(0.01).isZero()) {
                    return converted.toFixed(2);
                  } else {
                    return null;
                  }
                }

                if (converted.isLessThanOrEqualTo(2)) {
                  if (converted.modulo(1).isZero()) {
                    return converted.toFixed(0);
                  } else if (converted.modulo(0.1).isZero()) {
                    return converted.toFixed(1);
                  } else {
                    return null;
                  }
                }

                return common.separate_every_3digits(converted.toFixed(0, BigNumber.ROUND_DOWN));
              },
            }
          }]
        },
        tooltips: {
          callbacks: {
            label: function(tooltipItem, data) {
              const label = data.datasets[tooltipItem.datasetIndex].label;
              const value = new BigNumber(tooltipItem.yLabel / common.VALUE_RATE.number).toFixed(2, BigNumber.ROUND_DOWN);
              return `${label}: ${common.separate_every_3digits(value)}`;
            },
            afterLabel: function(tooltipItem, data) {
              return ` (${common.VALUE_RATE.label})`;
            },
          }
        }
      },
    };
  },
  mounted() {
    this.renderChart(this.chartData, this.options)
  }
}
</script>



// WEBPACK FOOTER //
// summarychart.vue?fa50d870